export default __webpack_public_path__ + "static/media/del.2870f5fc.png";